import {useNavigate} from "react-router-dom";

interface NavigateButtonProps {
  path: string;
  label: string;
  styleName: string;
  onClickFunc?: () => void;
}

const NavigateButton: React.FC<NavigateButtonProps> = ({ path, label, styleName, onClickFunc = undefined }) => {
  const navigate = useNavigate();

  return (
    <button onClick={() => {navigate(path); onClickFunc?.();}} className={styleName}>
      {label}
    </button>
  );
};

export default NavigateButton;
